var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __classPrivateFieldSet = (this && this.__classPrivateFieldSet) || function (receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return (kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value)), value;
};
var __classPrivateFieldGet = (this && this.__classPrivateFieldGet) || function (receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var _CPK_ethLibAdapter, _CPK_transactionManager, _CPK_contractManager, _CPK_networks, _CPK_ownerAccount, _CPK_saltNonce, _CPK_isConnectedToSafe;
import multiSendAbi from "./abis/MultiSendAbi.json";
import { defaultNetworks, normalizeNetworksConfig } from "./config/networks";
import ContractManager from "./contractManager";
// import SafeAppsSdkConnector from "./safeAppsSdkConnector";
import CpkTransactionManager from "./transactionManagers/CpkTransactionManager";
// import { checkConnectedToSafe } from "./utils/checkConnectedToSafe";
import { predeterminedSaltNonce } from "./utils/constants";
import { getHexDataLength, joinHexData } from "./utils/hexData";
// import { getNetworkIdFromName } from "./utils/networks";
import { normalizeGasLimit, OperationType, standardizeTransaction, } from "./utils/transactions";
class CPK {
    /**
     * Creates and initializes an instance of the CPK with the selected configuration parameters.
     *
     * @param opts - CPK configuration
     * @returns The CPK instance
     */
    static create(opts) {
        return __awaiter(this, void 0, void 0, function* () {
            const cpk = new CPK(opts);
            if (opts) {
                yield cpk.init();
            }
            return cpk;
        });
    }
    /**
     * Creates a non-initialized instance of the CPK with the selected configuration parameters.
     *
     * @param opts - CPK configuration
     * @returns The CPK instance
     */
    constructor(opts) {
        // #safeAppsSdkConnector?: SafeAppsSdkConnector;
        _CPK_ethLibAdapter.set(this, void 0);
        _CPK_transactionManager.set(this, void 0);
        _CPK_contractManager.set(this, void 0);
        _CPK_networks.set(this, void 0);
        _CPK_ownerAccount.set(this, void 0);
        _CPK_saltNonce.set(this, predeterminedSaltNonce);
        _CPK_isConnectedToSafe.set(this, false);
        __classPrivateFieldSet(this, _CPK_networks, Object.assign({}, defaultNetworks), "f");
        if (!opts) {
            return;
        }
        const { ethLibAdapter, transactionManager, ownerAccount, networks, saltNonce /* , isSafeApp = true */ } = opts;
        // if (isSafeApp) {
        //     this.#safeAppsSdkConnector = new SafeAppsSdkConnector();
        // }
        if (!ethLibAdapter) {
            throw new Error("ethLibAdapter property missing from options");
        }
        __classPrivateFieldSet(this, _CPK_ethLibAdapter, ethLibAdapter, "f");
        __classPrivateFieldSet(this, _CPK_transactionManager, transactionManager !== null && transactionManager !== void 0 ? transactionManager : new CpkTransactionManager(), "f");
        __classPrivateFieldSet(this, _CPK_ownerAccount, ownerAccount, "f");
        __classPrivateFieldSet(this, _CPK_networks, normalizeNetworksConfig(defaultNetworks, networks), "f");
        if (saltNonce) {
            __classPrivateFieldSet(this, _CPK_saltNonce, saltNonce, "f");
        }
    }
    /**
     * Initializes the CPK instance.
     */
    init() {
        return __awaiter(this, void 0, void 0, function* () {
            if (!__classPrivateFieldGet(this, _CPK_ethLibAdapter, "f")) {
                throw new Error("CPK uninitialized ethLibAdapter");
            }
            const networkId = yield __classPrivateFieldGet(this, _CPK_ethLibAdapter, "f").getNetworkId();
            const network = __classPrivateFieldGet(this, _CPK_networks, "f")[networkId];
            if (!network) {
                throw new Error(`Unrecognized network ID ${networkId}`);
            }
            const ownerAccount = yield this.getOwnerAccount();
            __classPrivateFieldSet(this, _CPK_isConnectedToSafe, false, "f");
            //    (await checkConnectedToSafe(this.#ethLibAdapter.getProvider())) ||
            //    this.#safeAppsSdkConnector?.isSafeApp === true;
            __classPrivateFieldSet(this, _CPK_contractManager, yield ContractManager.create({
                ethLibAdapter: __classPrivateFieldGet(this, _CPK_ethLibAdapter, "f"),
                network,
                ownerAccount,
                isSafeApp: false,
                isConnectedToSafe: __classPrivateFieldGet(this, _CPK_isConnectedToSafe, "f"),
            }), "f");
        });
    }
    /**
     * Checks if the Proxy contract is deployed or not. The deployment of the Proxy contract happens automatically when the first transaction is submitted.
     *
     * @returns TRUE when the Proxy contract is deployed
     */
    isProxyDeployed() {
        return __awaiter(this, void 0, void 0, function* () {
            const address = yield this.address;
            if (!address) {
                throw new Error("CPK address uninitialized");
            }
            if (!this.ethLibAdapter) {
                throw new Error("CPK ethLibAdapter uninitialized");
            }
            const codeAtAddress = yield this.ethLibAdapter.getCode(address);
            const isDeployed = codeAtAddress !== "0x";
            return isDeployed;
        });
    }
    /**
     * Returns the address of the account connected to the CPK (Proxy contract owner). However, if the CPK is running as a Safe App or connected to a Safe, the Safe address will be returned.
     *
     * @returns The address of the account connected to the CPK
     */
    getOwnerAccount() {
        var _a;
        return __awaiter(this, void 0, void 0, function* () {
            // if (this.#safeAppsSdkConnector?.isSafeApp) {
            //     return (await this.#safeAppsSdkConnector.getSafeInfo()).safeAddress;
            // }
            if (__classPrivateFieldGet(this, _CPK_ownerAccount, "f")) {
                return __classPrivateFieldGet(this, _CPK_ownerAccount, "f");
            }
            if (!__classPrivateFieldGet(this, _CPK_ethLibAdapter, "f")) {
                throw new Error("CPK uninitialized ethLibAdapter");
            }
            return (_a = __classPrivateFieldGet(this, _CPK_ethLibAdapter, "f")) === null || _a === void 0 ? void 0 : _a.getAccount();
        });
    }
    /**
     * Returns the ETH balance of the Proxy contract.
     *
     * @returns The ETH balance of the Proxy contract
     */
    getBalance() {
        var _a;
        return __awaiter(this, void 0, void 0, function* () {
            const address = yield this.address;
            if (!address) {
                throw new Error("CPK address uninitialized");
            }
            if (!__classPrivateFieldGet(this, _CPK_ethLibAdapter, "f")) {
                throw new Error("CPK ethLibAdapter uninitialized");
            }
            return (_a = __classPrivateFieldGet(this, _CPK_ethLibAdapter, "f")) === null || _a === void 0 ? void 0 : _a.getBalance(address);
        });
    }
    /**
     * Returns the ID of the connected network.
     *
     * @returns The ID of the connected network
     */
    getNetworkId() {
        return __awaiter(this, void 0, void 0, function* () {
            // if (this.#safeAppsSdkConnector?.isSafeApp) {
            //     const networkName = (await this.#safeAppsSdkConnector.getSafeInfo()).network;
            //     return getNetworkIdFromName(networkName);
            // }
            if (!__classPrivateFieldGet(this, _CPK_ethLibAdapter, "f")) {
                throw new Error("CPK ethLibAdapter uninitialized");
            }
            return __classPrivateFieldGet(this, _CPK_ethLibAdapter, "f").getNetworkId();
        });
    }
    /**
     * Returns the safeAppsSdkConnector used by the CPK.
     *
     * @returns The safeAppsSdkConnector used by the CPK
     */
    // get safeAppsSdkConnector(): SafeAppsSdkConnector | undefined {
    //     return this.#safeAppsSdkConnector;
    // }
    /**
     * Returns the contractManager used by the CPK.
     *
     * @returns The contractManager used by the CPK
     */
    get contractManager() {
        return __classPrivateFieldGet(this, _CPK_contractManager, "f");
    }
    /**
     * Returns the ethLibAdapter used by the CPK.
     *
     * @returns The ethLibAdapter used by the CPK
     */
    get ethLibAdapter() {
        return __classPrivateFieldGet(this, _CPK_ethLibAdapter, "f");
    }
    /**
     * Returns a list of the contract addresses which drive the CPK per network by network ID.
     *
     * @returns The list of the contract addresses which drive the CPK per network by network ID
     */
    get networks() {
        return __classPrivateFieldGet(this, _CPK_networks, "f");
    }
    /**
     * Checks if the CPK is connected to a Safe account or not.
     *
     * @returns TRUE if the CPK is connected to a Safe account
     */
    get isConnectedToSafe() {
        return __classPrivateFieldGet(this, _CPK_isConnectedToSafe, "f");
    }
    /**
     * Returns the salt nonce used to deploy the Proxy Contract.
     *
     * @returns The salt nonce used to deploy the Proxy Contract
     */
    get saltNonce() {
        return __classPrivateFieldGet(this, _CPK_saltNonce, "f");
    }
    /**
     * Returns the address of the Proxy contract.
     *
     * @returns The address of the Proxy contract
     */
    get address() {
        var _a, _b;
        // if (this.#safeAppsSdkConnector?.safeAddress) {
        //     return this.#safeAppsSdkConnector?.safeAddress;
        // }
        return (_b = (_a = __classPrivateFieldGet(this, _CPK_contractManager, "f")) === null || _a === void 0 ? void 0 : _a.contract) === null || _b === void 0 ? void 0 : _b.address;
    }
    /**
     * Sets the ethLibAdapter used by the CPK.
     */
    setEthLibAdapter(ethLibAdapter) {
        __classPrivateFieldSet(this, _CPK_ethLibAdapter, ethLibAdapter, "f");
    }
    /**
     * Sets the transactionManager used by the CPK.
     */
    setTransactionManager(transactionManager) {
        // if (this.#safeAppsSdkConnector?.isSafeApp) {
        //     throw new Error("TransactionManagers are not allowed when the app is running as a Safe App");
        // }
        __classPrivateFieldSet(this, _CPK_transactionManager, transactionManager, "f");
    }
    /**
     * Sets the network configuration used by the CPK.
     */
    setNetworks(networks) {
        __classPrivateFieldSet(this, _CPK_networks, normalizeNetworksConfig(defaultNetworks, networks), "f");
    }
    /**
     * Returns the encoding of a list of transactions.
     *
     * @param transactions - The transaction list
     * @returns The encoding of a list of transactions
     */
    encodeMultiSendCallData(transactions) {
        var _a;
        if (!__classPrivateFieldGet(this, _CPK_ethLibAdapter, "f")) {
            throw new Error("CPK ethLibAdapter uninitialized");
        }
        const multiSend = ((_a = __classPrivateFieldGet(this, _CPK_contractManager, "f")) === null || _a === void 0 ? void 0 : _a.multiSend) || __classPrivateFieldGet(this, _CPK_ethLibAdapter, "f").getContract(multiSendAbi);
        const standardizedTxs = transactions.map(standardizeTransaction);
        const ethLibAdapter = __classPrivateFieldGet(this, _CPK_ethLibAdapter, "f");
        return multiSend.encode("multiSend", [
            joinHexData(standardizedTxs.map(tx => ethLibAdapter.abiEncodePacked({ type: "uint8", value: tx.operation }, { type: "address", value: tx.to }, { type: "uint256", value: tx.value }, { type: "uint256", value: getHexDataLength(tx.data) }, { type: "bytes", value: tx.data }))),
        ]);
    }
    /**
     * Executes a list of transactions.
     *
     * @param transactions - The transaction list to execute
     * @param options - Execution configuration options
     * @returns The transaction response
     */
    execTransactions(transactions, options) {
        return __awaiter(this, void 0, void 0, function* () {
            const standardizedTxs = transactions.map(standardizeTransaction);
            // if (this.#safeAppsSdkConnector?.isSafeApp && transactions.length >= 1) {
            //    return this.#safeAppsSdkConnector.sendTransactions(standardizedTxs, {
            //        safeTxGas: options?.safeTxGas,
            //    });
            // }
            const address = yield this.address;
            if (!address) {
                throw new Error("CPK address uninitialized");
            }
            if (!__classPrivateFieldGet(this, _CPK_contractManager, "f")) {
                throw new Error("CPK contractManager uninitialized");
            }
            if (!__classPrivateFieldGet(this, _CPK_ethLibAdapter, "f")) {
                throw new Error("CPK ethLibAdapter uninitialized");
            }
            if (!__classPrivateFieldGet(this, _CPK_transactionManager, "f")) {
                throw new Error("CPK transactionManager uninitialized");
            }
            const ownerAccount = yield this.getOwnerAccount();
            if (!ownerAccount) {
                throw new Error("CPK ownerAccount uninitialized");
            }
            const safeExecTxParams = this.getSafeExecTxParams(transactions);
            const sendOptions = normalizeGasLimit(Object.assign(Object.assign({}, options), { from: ownerAccount }));
            const codeAtAddress = yield __classPrivateFieldGet(this, _CPK_ethLibAdapter, "f").getCode(address);
            const isDeployed = codeAtAddress !== "0x";
            return __classPrivateFieldGet(this, _CPK_transactionManager, "f").execTransactions(Object.assign(Object.assign(Object.assign({ ownerAccount,
                safeExecTxParams, transactions: standardizedTxs, ethLibAdapter: __classPrivateFieldGet(this, _CPK_ethLibAdapter, "f"), contractManager: __classPrivateFieldGet(this, _CPK_contractManager, "f"), saltNonce: __classPrivateFieldGet(this, _CPK_saltNonce, "f"), isDeployed, isConnectedToSafe: __classPrivateFieldGet(this, _CPK_isConnectedToSafe, "f") }, ((options === null || options === void 0 ? void 0 : options.nonce) && {
                nonce: options === null || options === void 0 ? void 0 : options.nonce,
            })), (!(options === null || options === void 0 ? void 0 : options.nonce) &&
                (options === null || options === void 0 ? void 0 : options.nonceOffset) && {
                nonceOffset: options === null || options === void 0 ? void 0 : options.nonceOffset,
            })), { sendOptions }));
        });
    }
    /**
     * Returns the Master Copy contract version.
     *
     * @returns The Master Copy contract version
     */
    getContractVersion() {
        var _a;
        return __awaiter(this, void 0, void 0, function* () {
            const isProxyDeployed = yield this.isProxyDeployed();
            if (!isProxyDeployed) {
                throw new Error("CPK Proxy contract is not deployed");
            }
            if (!((_a = __classPrivateFieldGet(this, _CPK_contractManager, "f")) === null || _a === void 0 ? void 0 : _a.versionUtils)) {
                throw new Error("CPK contractManager uninitialized");
            }
            return yield __classPrivateFieldGet(this, _CPK_contractManager, "f").versionUtils.getContractVersion();
        });
    }
    /**
     * Returns the list of addresses of all the enabled Safe modules.
     *
     * @returns The list of addresses of all the enabled Safe modules
     */
    getModules() {
        var _a;
        return __awaiter(this, void 0, void 0, function* () {
            const isProxyDeployed = yield this.isProxyDeployed();
            if (!isProxyDeployed) {
                throw new Error("CPK Proxy contract is not deployed");
            }
            if (!((_a = __classPrivateFieldGet(this, _CPK_contractManager, "f")) === null || _a === void 0 ? void 0 : _a.versionUtils)) {
                throw new Error("CPK contractManager uninitialized");
            }
            return yield __classPrivateFieldGet(this, _CPK_contractManager, "f").versionUtils.getModules();
        });
    }
    /**
     * Checks if a specific Safe module is enabled or not.
     *
     * @param moduleAddress - The desired module address
     * @returns TRUE if the module is enabled
     */
    isModuleEnabled(moduleAddress) {
        var _a;
        return __awaiter(this, void 0, void 0, function* () {
            const isProxyDeployed = yield this.isProxyDeployed();
            if (!isProxyDeployed) {
                throw new Error("CPK Proxy contract is not deployed");
            }
            if (!((_a = __classPrivateFieldGet(this, _CPK_contractManager, "f")) === null || _a === void 0 ? void 0 : _a.versionUtils)) {
                throw new Error("CPK contractManager uninitialized");
            }
            return yield __classPrivateFieldGet(this, _CPK_contractManager, "f").versionUtils.isModuleEnabled(moduleAddress);
        });
    }
    /**
     * Enables a Safe module
     *
     * @param moduleAddress - The desired module address
     * @returns The transaction response
     */
    enableModule(moduleAddress) {
        var _a;
        return __awaiter(this, void 0, void 0, function* () {
            if (!((_a = __classPrivateFieldGet(this, _CPK_contractManager, "f")) === null || _a === void 0 ? void 0 : _a.versionUtils)) {
                throw new Error("CPK contractManager uninitialized");
            }
            const address = yield this.address;
            if (!address) {
                throw new Error("CPK address uninitialized");
            }
            return yield this.execTransactions([
                {
                    to: address,
                    data: yield __classPrivateFieldGet(this, _CPK_contractManager, "f").versionUtils.encodeEnableModule(moduleAddress),
                    operation: CPK.Call,
                },
            ]);
        });
    }
    /**
     * Disables a Safe module
     *
     * @param moduleAddress - The desired module address
     * @returns The transaction response
     */
    disableModule(moduleAddress) {
        var _a;
        return __awaiter(this, void 0, void 0, function* () {
            const isProxyDeployed = yield this.isProxyDeployed();
            if (!isProxyDeployed) {
                throw new Error("CPK Proxy contract is not deployed");
            }
            if (!((_a = __classPrivateFieldGet(this, _CPK_contractManager, "f")) === null || _a === void 0 ? void 0 : _a.versionUtils)) {
                throw new Error("CPK contractManager uninitialized");
            }
            const address = yield this.address;
            if (!address) {
                throw new Error("CPK address uninitialized");
            }
            return yield this.execTransactions([
                {
                    to: address,
                    data: yield __classPrivateFieldGet(this, _CPK_contractManager, "f").versionUtils.encodeDisableModule(moduleAddress),
                    operation: CPK.Call,
                },
            ]);
        });
    }
    getSafeExecTxParams(transactions) {
        var _a, _b;
        if (transactions.length === 1) {
            return standardizeTransaction(transactions[0]);
        }
        if (!((_a = __classPrivateFieldGet(this, _CPK_contractManager, "f")) === null || _a === void 0 ? void 0 : _a.multiSend)) {
            throw new Error("CPK MultiSend uninitialized");
        }
        return {
            to: (_b = __classPrivateFieldGet(this, _CPK_contractManager, "f")) === null || _b === void 0 ? void 0 : _b.multiSend.address,
            value: "0",
            data: this.encodeMultiSendCallData(transactions),
            operation: CPK.DelegateCall,
        };
    }
}
_CPK_ethLibAdapter = new WeakMap(), _CPK_transactionManager = new WeakMap(), _CPK_contractManager = new WeakMap(), _CPK_networks = new WeakMap(), _CPK_ownerAccount = new WeakMap(), _CPK_saltNonce = new WeakMap(), _CPK_isConnectedToSafe = new WeakMap();
CPK.Call = OperationType.Call;
CPK.DelegateCall = OperationType.DelegateCall;
export default CPK;
